// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6536":"17b5efcb","9085":"1de9d292"}[chunkId] + ".chunk.css";
};